




















































































































import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';
import VueToExcel from 'vue-json-excel';
import Loading from '@/shared/loading/loading.component.vue';
import CandidatePersonalityResult from '@/domain/selective-process/entity/candidate/candidate-personality-result.entity';
import CandidateService from '@/domain/selective-process/service/candidate.service';
import PersonalityTableHeaders from '../candidate/personality-table-header.json';
import PersonalityAnswerHeaders from './personality-answer-header.json';
import ResetSurveyModal from '../modal/reset-survey-modal.component.vue';

@Component({
  components: {
    VueApexCharts,
    Loading,
    ResetSurveyModal,
    VueToExcel,
  },
})
export default class PersonalityResultComponent extends Vue {
  @Prop({
    type: String,
    required: true,
  }) candidateAssessmentId!: string;

  @Prop({
    type: Boolean,
    required: true,
  }) hasResetPermission!: boolean;

  @Prop({
    type: String,
    required: true,
  }) candidateName!: string;

  personalityResult: CandidatePersonalityResult = new CandidatePersonalityResult();

  personalityHeaders = PersonalityTableHeaders;

  personalityAnswerHeaders = PersonalityAnswerHeaders;

  loading: boolean = false;

  showAnswers: boolean = false;

  openResetModal: boolean = false;

  personalityResultChartOptions = {
    chart: {
      type: 'bar',
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: true,
        barHeight: '70%',
        dataLabels: {
          position: 'left',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [''],
      min: 0,
      max: 100,
      labels: {
        style: {
          fontSize: '14px',
          fontFamily: 'Roboto',
          fontWeight: 400,
          textAlign: 'left',
        },
      },
      title: {
        text: 'Percentil',
        style: {
          fontSize: '16px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
        },
      },
    },
    tooltip: {
      followCursor: true,
      y: {
        formatter: value => `${value}%`,
        title: {
          formatter: () => '',
        },
      },
    },
  }

  personalityResultChartSeries: any[] = [{
    data: [],
  }]

  xlsFields: any = {
    Questão: 'questionPosition',
    Titulo: 'questionTitle',
    Resposta: 'answerValue',
    Categoria: 'questionPersonalityFactorName',
  }

  created() {
    this.getPersonalityResult();
  }

  async getPersonalityResult() {
    this.loading = true;
    await CandidateService.getPersonalityResult(this.candidateAssessmentId)
      .then((response) => {
        this.personalityResult = response;
        this.setChartData();
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setChartData() {
    this.personalityResultChartSeries[0].data = this.personalityResult
      .results.map(it => it.percent);
    this.personalityResultChartOptions.xaxis.categories = this.personalityResult
      .results.map(it => it.factorName);
  }

  formatDateTime(date: string): string {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  get duration() {
    const start = moment(this.personalityResult.startedDate);
    const end = moment(this.personalityResult.concludedDate);
    moment.locale('pt-br')
    return moment.duration(end.diff(start)).humanize();
  }
}
